import httpClient from '@/plugins/axios'

const toggleLoading = ({ commit }, payload: boolean) => {
  commit('TOGGLE_LOADING', payload)
}

const toggleSearchContent = ({ commit }, payload: boolean) => {
  commit('TOGGLE_SEARCH_CONTENT', payload)
}

const toggleUserHeader = ({ commit }, payload: boolean) => {
  commit('TOGGLE_USER_HEADER', payload)
}

const toggleSideBarContent = ({ commit }, payload: boolean) => {
  commit('TOGGLE_SIDEBAR_CONTENT_HEADER', payload)
}

const toggleNavigationBar = ({ commit }, payload: boolean) => {
  commit('TOGGLE_NAVIGATION_BAR', payload)
}

const setCurrentSkill = ({ commit }, payload: object) => {
  commit('SET_CURRENT_SKILL', payload)
}

const setCurrentSpPage = ({ commit }, payload: object) => {
  commit('SET_CURRENT_SP_PAGE', payload)
}

const setScrollHistory = ({ commit }, payload: number) => {
  commit('SET_SCROLL_HISTORY', payload)
}

const setState = ({ commit }, payload: { key: string; value: any }) => {
  commit('SET_STATE', payload)
}

const setRefreshQuestionCount = ({ commit }, payload: boolean) => {
  commit('SET_REFRESH_QUESTION_COUNT', payload)
}

const handleError = (context: any, e: any) => {
  if (process.env.NODE_ENV !== 'production') console.log(e)
  // if (e.response && e.response.data.message) {
  //   alert(e.response.data.message);
  // } else {
  //   alert('システムーエラーが発生しました');
  // }
  throw e
}

export const apiGet = async (
  context: any,
  url: string,
  payload?: any
): Promise<any> => {
  try {
    const data = await httpClient.get(url, payload)
    return data
  } catch (error) {
    handleError(context, error)
  }
}

export const apiPost = async (
  context: any,
  url: string,
  payload?: any
): Promise<any> => {
  try {
    const data = await httpClient.post(url, payload)
    return data
  } catch (error) {
    handleError(context, error)
  }
}

export const apiPut = async (
  context: any,
  url: string,
  payload?: any
): Promise<any> => {
  try {
    const data = await httpClient.post(url, payload)
    return data
  } catch (error) {
    handleError(context, error)
  }
}

export const apiDelete = async (
  context: any,
  url: string,
  payload?: any
): Promise<any> => {
  try {
    const data = await httpClient.delete(url, payload)
    return data
  } catch (error) {
    handleError(context, error)
  }
}

const sendEventLog = async (context: any, payload: string) => {
  try {
    const { data } = await apiPost(context, '/event-logs', { path: payload })
    return data
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error)
  }
}

export default {
  toggleLoading,
  setCurrentSkill,
  setCurrentSpPage,
  toggleSearchContent,
  toggleUserHeader,
  toggleSideBarContent,
  toggleNavigationBar,
  setScrollHistory,
  setState,
  setRefreshQuestionCount,
  sendEventLog
}
